<template>
	<div
		data-component="lesson-resource-item-base"
		v-if="getShowResource"
	>
		<icon
			data-element="document-icon"
			icon="v2-file-filled"
			colour="transparent"
		/>
		<a
			data-element="filename"
			:href="getUrl"
		>
			{{ getFilename }}
		</a>
		<slot />
	</div>
</template>

<script>

	import Icon from '@/components/ui/Icon';

	export default {
		components: {
			Icon
		},
		props: {
			resource: {
				type: Object,
				default: () => ({})
			}
		},
		computed: {
			getShowResource () {
				if (!this.getUrl ||
						!this.getFilename) {
					return false;
				}
				return true;
			},
			getUrl () {
				return this.resource.url;
			},
			getFilename () {
				return this.resource?.originalname;
			},
			getDescription () {
				return this.resource?.description;
			}
		},
		methods: {}
	};

</script>

<style lang="scss" scoped>
	[data-component='lesson-resource-item-base'] {
		display: flex;
		align-items: center;
		::v-deep [data-element="document-icon"] {
			flex-shrink: 0;
			width: 22px;
			height: auto;
			margin: 0 2px;
			* {
				fill: $c-brand-grey-lighter-1;
			}
		}
		[data-element='filename'] {
			overflow: hidden;
			width: 100%;
			white-space: nowrap;
			text-overflow: ellipsis;
			@include font(16px, $c-brand-grey, 500, 20px);
		}
	}
</style>
